import { createContext } from "react";
import { GlobalClientSettings } from "consumerhouse-shared";

export const StatusContext = createContext<GlobalClientSettings | null>(null);
